
(function (window, document, undefined) {
L.SVGIcon = L.Icon.extend({
    statics: {
        CACHE_NODE: {},
        CACHE_URL: {}
    },

    options: {
        iconSize: [24, 24]
    },

    _createIcon: function (name, oldIcon) {
        var src = this._getIconUrl(name);

        if (!src) {
            if (name === 'icon') {
                throw new Error('iconUrl not set in Icon options (see the docs).');
            }
            return null;
        }

        var img;
        if (!oldIcon || oldIcon.tagName !== 'OBJECT') {
            img = this._createImg(src);
        } else {
            img = this._createImg(src, oldIcon);
        }
        this._setIconStyles(img, name);

        img._src = src;
        return img;
    },

    _setIconStyles: function (img, name) {
        var options = this.options,
            size = L.point(options[name + 'Size']),
            anchor;

        anchor = L.point(options.iconAnchor);

        if (!anchor && size) {
            anchor = size.divideBy(2, true);
        }

        img.className = 'leaflet-marker-' + name + ' ' + options.className;

        img.addEventListener('load', this._onload, true);

        if (anchor) {
            img.style.marginLeft = (-anchor.x) + 'px';
            img.style.marginTop  = (-anchor.y) + 'px';
        }

        if (size) {
            img.style.width  = size.x + 'px';
            img.style.height = size.y + 'px';
        }

        img.options = options;
    },

    _createImg: function (src, el) {
        var self = this;
        el = el || document.createElement('div');

        if (L.SVGIcon.CACHE_NODE[src]) {
            el.innerHTML = '';
            svg_elem = L.SVGIcon.CACHE_NODE[src].cloneNode(true);
            el.appendChild(svg_elem);
            self._onload(svg_elem);
        }
        else if (L.SVGIcon.CACHE_URL[src]) {
            setTimeout(function(){
                self._createImg(src, el);
            }, 100);
        }
        else {
            var _obj = null;
            var _sub_list = el.getElementsByTagName('object');
            for (var i=0; i<_sub_list.length; i++) {
                _obj = _sub_list[i];
                break;
            }
            if (!_obj) {
                _obj = document.createElement('object');
                _obj.type = "image/svg+xml";
                el.appendChild(_obj);
            }
            L.SVGIcon.CACHE_URL[src] = true;
            _obj.data = src;

            el._svg_object = _obj;
        }

        return el;
    },

    _getIconUrl: function (name) {
        return this.options[name + 'Url'];
    },

    _onload: function (elem) {
        var options = this.options;

        var fill_color = function(svg_elem, tag_name, color) {
            if (svg_elem && svg_elem.nodeName == "svg") {
                var tag_list = svg_elem.getElementsByTagName(tag_name);
                for (i=tag_list.length-1; i>=0; i--) {
                    var tag = tag_list[i];
                    tag.style.fill = color;
                }
            }
        }

        var elem_list, elem, i, svg_elem = null;
        if (this._svg_object) {
            var svgDoc = this._svg_object.contentDocument;
            //
            // this using for leaflet-image to dump image
            //
            this.contentDocument = svgDoc;

            elem_list = svgDoc.getElementsByTagName('svg');
            for (i=elem_list.length-1; i>=0; i--) {
                svg_elem = elem_list[i];

                // clone and cache svg node
                L.SVGIcon.CACHE_NODE[this._src] = svg_elem.cloneNode(true);

                if (options.opacity) {
                    svg_elem.style.opacity = options.opacity;
                }
            }
        }
        else {
            svg_elem = elem;
        }

        if (options.pathColor) {
            fill_color(svg_elem, 'path', options.pathColor);
        }
        if (options.circleColor) {
            fill_color(svg_elem, 'circle', options.circleColor);
        }
        if (options.polygonColor) {
            fill_color(svg_elem, 'polygon', options.polygonColor);
        }
        if (options.rectColor) {
            fill_color(svg_elem, 'rect', options.rectColor);
        }
    }
});

L.svgIcon = function (options) {
    return new L.SVGIcon(options);
};

}(this, document));



// WEBPACK FOOTER //
// ./src/assets/cb/leaflet/leaflet.svgicon.js